import { render, staticRenderFns } from "./SparkList.vue?vue&type=template&id=582900ac&scoped=true&"
import script from "./SparkList.vue?vue&type=script&lang=ts&"
export * from "./SparkList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582900ac",
  null
  
)

export default component.exports